import {userConstants } from "../_constants/";

export function users(state = {}, action) {
  switch (action.type) {
    case userConstants.REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_SUCCESS:
      return {
        items: action.users,
      };
    case userConstants.SAVE_SUCCESS:
      return {
        item: action.user,
      };
    case userConstants.GET_SINGLE_SUCCESS:
      return {
        item: action.user.data,
      };
    case userConstants.FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

